import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useVoterAuth } from '../contexts/VoterAuthContext';
import client from '../api/client';

export default function VoterHistory() {
  const { voter } = useVoterAuth();
  const navigate = useNavigate();
  const [votes, setVotes] = useState([]);
  const [loading, setLoading] = useState(true);

  const downloadReceipt = () => {
    console.log("downloading...");
    return;
  };

  useEffect(() => {
    if (!voter) { navigate('/vote/login'); return; }
    client.get('/voter/history').then(res => {
      setVotes(res.data);
      setLoading(false);
    }).catch(() => setLoading(false));
  }, [voter, navigate]);

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h1>Voting History</h1>
        <button onClick={downloadReceipt} className="btn-secondary">Download PDF Receipt</button>
      </div>
      {loading ? (
        <p>Loading...</p>
      ) : votes.length === 0 ? (
        <div className="card">
          <p>No voting history found.</p>
        </div>
      ) : (
        <div className="votes-list">
          {votes.map(vote => (
            <div key={vote.id} className="card">
              <div className="vote-row">
                <span>Candidate:</span>
                <strong>{vote.candidate_name || 'Unknown'}</strong>
              </div>
              <div className="vote-row">
                <span>Party:</span>
                <strong>{vote.party_name || 'Unknown'}</strong>
              </div>
              <div className="vote-row">
                <span>Constituency:</span>
                <strong>{vote.constituency_name || 'Unknown'}</strong>
              </div>
              <div className="vote-row">
                <span>Cast At:</span>
                <strong>{new Date(vote.cast_at).toLocaleString()}</strong>
              </div>
            </div>
          ))}
        </div>
      )}
      <button onClick={() => navigate('/vote/dashboard')} className="btn-secondary" style={{ marginTop: '1rem' }}>
        Back to Dashboard
      </button>
    </div>
  );
}
